import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAspectRatio169: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconAspectRatio169"><Path d="M3.75 5C2.23122 5 1 6.23122 1 7.75V16.25C1 17.7688 2.23122 19 3.75 19H20.25C21.7688 19 23 17.7688 23 16.25V7.75C23 6.23122 21.7688 5 20.25 5H3.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAspectRatio169;
